// Visual identity for parties: dot colour, chip background, chip text color, left border accent.
// Keyed by the short code (PMK, DMK, AIADMK, etc.)

const BASE = {
  DMK: { dot: "#f59e0b", bg: "#fff1e6", text: "#b4370c", accent: "#c8232c" },
  AIADMK: { dot: "#10b981", bg: "#e6f8f1", text: "#066b4e", accent: "#16a34a" },
  BJP: { dot: "#ea580c", bg: "#ffe7d6", text: "#9a3412", accent: "#ea580c" },
  INC: { dot: "#3b82f6", bg: "#e3edff", text: "#1e3a8a", accent: "#2563eb" },
  TVK: { dot: "#eab308", bg: "#fff8d6", text: "#854d0e", accent: "#eab308" },
  NTK: { dot: "#ef4444", bg: "#ffe4e6", text: "#991b1b", accent: "#dc2626" },
  PMK: { dot: "#f97316", bg: "#ffedd5", text: "#9a3412", accent: "#f97316" },
  CPI: { dot: "#dc2626", bg: "#fee2e2", text: "#991b1b", accent: "#dc2626" },
  "CPI-M": { dot: "#dc2626", bg: "#fee2e2", text: "#991b1b", accent: "#dc2626" },
  MDMK: { dot: "#f43f5e", bg: "#ffe4e6", text: "#9f1239", accent: "#e11d48" },
  VCK: { dot: "#0ea5e9", bg: "#e0f2fe", text: "#075985", accent: "#0284c7" },
  IUML: { dot: "#16a34a", bg: "#dcfce7", text: "#166534", accent: "#16a34a" },
  DMDK: { dot: "#9333ea", bg: "#f3e8ff", text: "#6b21a8", accent: "#9333ea" },
  AMMK: { dot: "#14b8a6", bg: "#ccfbf1", text: "#115e59", accent: "#0d9488" },
  AINRC: { dot: "#f472b6", bg: "#fce7f3", text: "#9d174d", accent: "#db2777" },
  IND: { dot: "#64748b", bg: "#e2e8f0", text: "#334155", accent: "#475569" },
  INDEPENDENT: { dot: "#64748b", bg: "#e2e8f0", text: "#334155", accent: "#475569" },
};

const FALLBACK = { dot: "#7c3aed", bg: "#ede9fe", text: "#4c1d95", accent: "#7c3aed" };

export function partyColors(shortOrName) {
  if (!shortOrName) return FALLBACK;
  const key = String(shortOrName).toUpperCase().trim();
  return BASE[key] || FALLBACK;
}

// Simple dot icon — keeps things consistent and avoids emoji
export function partyEmoji(shortOrName) {
  const key = String(shortOrName || "").toUpperCase().trim();
  const map = {
    DMK: "●",
    AIADMK: "●",
    BJP: "●",
    TVK: "●",
    NTK: "●",
    PMK: "●",
  };
  return map[key] || "●";
}
